(() => {
  const money = (cents, currency = 'AUD') => new Intl.NumberFormat('en-AU', {
    style: 'currency', currency, maximumFractionDigits: cents % 100 === 0 ? 0 : 2
  }).format(cents / 100);

  const navToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  navToggle?.addEventListener('click', () => {
    const open = mobileNav.dataset.open !== 'true';
    mobileNav.dataset.open = String(open);
    navToggle.setAttribute('aria-expanded', String(open));
  });

  document.querySelectorAll('[data-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[role="tab"]');
    const panels = tabs.parentElement.querySelectorAll('[role="tabpanel"]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
      panels.forEach((panel) => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
    }));
  });

  document.querySelectorAll('[data-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input');
    quantity.querySelector('[data-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });
    quantity.querySelector('[data-plus]')?.addEventListener('click', () => {
      input.value = Math.min(Number(input.max || 99), Number(input.value || 1) + 1);
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const data = root.querySelector('[data-variants-json]');
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const form = root.querySelector('[data-product-form]');
    const variantInput = form?.querySelector('[name="id"]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const availability = root.querySelector('[data-availability]');
    const saleNote = root.querySelector('[data-sale-note]');
    if (compare) compare.hidden = true;
    if (saleNote) saleNote.hidden = true;
    const submit = form?.querySelector('[type="submit"]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyButton = document.querySelector('[data-sticky-submit]');
    const launchEligible = root.dataset.launchEligible === 'true';

    const selectVariant = (id) => {
      const variant = variants.find((item) => String(item.id) === String(id));
      if (!variant) return;
      variantInput.value = variant.id;
      if (price && launchEligible) price.textContent = money(variant.price, root.dataset.currency || 'AUD');
      if (stickyPrice) stickyPrice.textContent = launchEligible ? money(variant.price, root.dataset.currency || 'AUD') : 'Price pending';
      // An old compare-at value is not evidence of a previous selling price.
      if (compare) compare.hidden = true;
      if (saleNote) saleNote.hidden = true;
      const commerceEnabled = launchEligible && variant.available;
      if (availability) availability.textContent = commerceEnabled ? 'Available to order' : 'Currently unavailable';
      if (submit) {
        submit.disabled = !commerceEnabled;
        submit.textContent = commerceEnabled ? 'Add to cart' : 'Currently unavailable';
      }
      if (stickyButton) {
        stickyButton.disabled = !commerceEnabled;
        stickyButton.textContent = commerceEnabled ? 'Add to cart' : 'Currently unavailable';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    root.querySelectorAll('[data-variant-id]').forEach((control) => {
      control.addEventListener('change', () => selectVariant(control.dataset.variantId));
    });
    stickyButton?.addEventListener('click', () => submit?.click());
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-gallery]');
      const target = gallery?.querySelector('[data-gallery-main]');
      if (!target) return;
      target.src = thumb.dataset.image;
      target.alt = thumb.dataset.alt || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', String(item === thumb)));
    });
  });

  const updateCartCount = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
      const cartLink = node.closest('[data-cart-drawer-toggle]');
      cartLink?.setAttribute('aria-label', `Cart with ${cart.item_count} items`);
    });
  };

  const getCartDrawer = () => document.querySelector('[data-cart-drawer]');
  const openCartDrawer = () => {
    const drawer = getCartDrawer();
    if (!drawer) return;
    drawer.dataset.open = 'true';
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    document.querySelectorAll('[data-cart-drawer-toggle]').forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
    drawer.querySelector('.cart-drawer')?.focus({ preventScroll: true });
  };
  const closeCartDrawer = () => {
    const drawer = getCartDrawer();
    if (!drawer) return;
    drawer.dataset.open = 'false';
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    document.querySelectorAll('[data-cart-drawer-toggle]').forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
  };
  const refreshCartDrawer = async ({ open = false } = {}) => {
    if (!window.drive4kRoutes?.cartDrawerSection) return;
    const response = await fetch(window.drive4kRoutes.cartDrawerSection, { headers: { 'Accept': 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh the cart. Please try again.');
    const sections = await response.json();
    const html = sections['cart-drawer'];
    if (!html) return;
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    const nextDrawer = template.content.querySelector('[data-cart-drawer]');
    const currentDrawer = getCartDrawer();
    if (nextDrawer && currentDrawer) currentDrawer.replaceWith(nextDrawer);
    if (open) openCartDrawer();
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-drawer-toggle]');
    if (toggle) {
      event.preventDefault();
      openCartDrawer();
      return;
    }
    if (event.target.closest('[data-cart-drawer-close]')) closeCartDrawer();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCartDrawer();
  });

  document.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-cart-drawer-quantity]');
    if (!input) return;
    const quantity = Math.max(0, Number(input.value || 0));
    input.disabled = true;
    try {
      const response = await fetch(window.drive4kRoutes.cartChange, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(input.dataset.line), quantity })
      });
      if (!response.ok) throw new Error('Unable to update the cart. Please try again.');
      const cart = await response.json();
      updateCartCount(cart);
      await refreshCartDrawer({ open: true });
    } catch (error) {
      input.disabled = false;
      const drawer = getCartDrawer();
      let errorMessage = drawer?.querySelector('[data-cart-drawer-error]');
      if (!errorMessage && drawer) {
        errorMessage = document.createElement('p');
        errorMessage.dataset.cartDrawerError = '';
        errorMessage.setAttribute('role', 'alert');
        drawer.querySelector('.cart-drawer__body')?.prepend(errorMessage);
      }
      if (errorMessage) errorMessage.textContent = error.message;
    }
  });

  document.addEventListener('click', async (event) => {
    const remove = event.target.closest('[data-cart-drawer-remove]');
    if (!remove) return;
    remove.disabled = true;
    try {
      const response = await fetch(window.drive4kRoutes.cartChange, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(remove.dataset.line), quantity: 0 })
      });
      if (!response.ok) throw new Error('Unable to remove the item. Please try again.');
      const cart = await response.json();
      updateCartCount(cart);
      await refreshCartDrawer({ open: true });
    } catch (error) {
      remove.disabled = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent || 'Add to cart';
    let errorMessage = form.querySelector('[data-cart-error]');
    if (!errorMessage) {
      errorMessage = document.createElement('p');
      errorMessage.dataset.cartError = '';
      errorMessage.setAttribute('role', 'alert');
      form.append(errorMessage);
    }
    errorMessage.hidden = true;
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
    try {
      const response = await fetch(window.drive4kRoutes.cartAdd, {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      });
      if (!response.ok) {
        const detail = await response.json().catch(() => ({}));
        throw new Error(detail.description || detail.message || 'Unable to add this item. Please try again.');
      }
      const cart = await fetch(window.drive4kRoutes.cartJson).then((result) => result.json());
      updateCartCount(cart);
      if (button) button.textContent = 'Added';
      await refreshCartDrawer({ open: true });
      window.setTimeout(() => {
        if (button) {
          button.textContent = original;
          button.disabled = false;
        }
      }, 900);
    } catch (error) {
      errorMessage.textContent = error.message;
      errorMessage.hidden = false;
      if (button) {
        button.textContent = original;
        button.disabled = false;
      }
    }
  });
})();
